import { render, staticRenderFns } from "./new-group.vue?vue&type=template&id=21ca55a2"
import script from "./new-group.vue?vue&type=script&lang=js"
export * from "./new-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ca55a2')) {
      api.createRecord('21ca55a2', component.options)
    } else {
      api.reload('21ca55a2', component.options)
    }
    module.hot.accept("./new-group.vue?vue&type=template&id=21ca55a2", function () {
      api.rerender('21ca55a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/group/new-group.vue"
export default component.exports